module.exports = __webpack_public_path__ + "img/flag-active.ed8bdc49.svg";